import LockIcon from "@mui/icons-material/Lock";
import { Box, Button, Stack, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useNavigate } from "react-router-dom";

import { BookedPriceRevealTier } from "./BookedPriceRevealTier";
import { CompetitivenessTier } from "./tiers";
import {
  BG_ICON_COLOR,
  CARRIER_UPGRADE_RELATIVE_URL,
  CarrierUpgradeSource,
} from "../../../../constants";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { captureCarrierUpgradeCtaClicked } from "../../../../utils";

export function BookedPriceRevealLocked() {
  const posthog = usePostHog();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: "grey.300",
        bgcolor: "#FEFEFE",
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          pointerEvents: "none",
          userSelect: "none",
          filter: "blur(6px)",
          opacity: 0.4,
        }}
      >
        <Box sx={{ width: "100%" }}>
          <BookedPriceRevealTier tier={CompetitivenessTier.COMPETITIVE} />
        </Box>
      </Box>

      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          position: "relative",
          zIndex: 1,
          py: isMobile ? 3 : 4,
          px: isMobile ? 2 : 3,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "grey.100",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          <LockIcon sx={{ fontSize: 20, color: "grey.500" }} />
        </Box>

        <Typography
          variant="body2"
          fontWeight={500}
          sx={{ color: BG_ICON_COLOR, mb: 0.5 }}
        >
          See how competitive your quote was
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mb: 2,
            maxWidth: isMobile ? "none" : 320,
          }}
        >
          Upgrade to find out how close your quote was to the booked price and
          improve your win rate.
        </Typography>

        <Button
          variant="contained"
          onClick={() => {
            captureCarrierUpgradeCtaClicked(
              posthog,
              CarrierUpgradeSource.BOOKED_PRICE_REVEAL,
            );
            window.history.pushState({}, window.location.href);
            navigate(CARRIER_UPGRADE_RELATIVE_URL);
          }}
          sx={{
            bgcolor: "#F5C518",
            color: BG_ICON_COLOR,
            fontWeight: 500,
            textTransform: "none",
            "&:hover": { bgcolor: "#E5B700" },
          }}
        >
          Upgrade Now
        </Button>
      </Stack>
    </Box>
  );
}
